import { CircleAlert } from 'lucide-react';
import { useState } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '@/context/CoginitoAuthProvider';
import { UserRoleEnum } from '@/types/User';
import { SideBarItemList } from '@/utils/data/nav';

import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

const Sidebar = () => {
  const { logout } = useAuth();

  const [isAddProduct, setIsAddProduct] = useState(false);

  return (
    <aside
      id="sidebar"
      aria-label="Sidebar"
      className="fixed h-full w-[inherit] flex flex-col px-5 py-6 overflow-y-auto"
    >
      <h5 className="text-xl font-bold mb-6">Dome admin</h5>

      {Object.entries(SideBarItemList).map(([key, value]) => (
        <div key={key} className="text-neutral-600">
          <h6 className="text-xs py-2">{key}</h6>
          <div>
            {value.map((v, i) => (
              <React.Fragment key={i}>
                {v.path === '/add-product' ? (
                  <Popover>
                    <PopoverTrigger
                      onClick={() => setIsAddProduct(true)}
                      className={`flex w-full relative items-center gap-x-2 py-2 px-4 ${isAddProduct ? 'bg-slate-800 rounded-md' : ''}`}
                    >
                      <v.icon size={15} type="solid" />
                      <p className="text-base">{v.label}</p>
                    </PopoverTrigger>
                    {isAddProduct && (
                      <PopoverContent
                        className="w-72"
                        sideOffset={10}
                        side="right"
                        align="start"
                      >
                        <ImportFileModal />
                      </PopoverContent>
                    )}
                  </Popover>
                ) : (
                  <Link
                    className={`flex relative items-center w-full gap-x-2 py-2 px-4 ${location.pathname === v.path && !isAddProduct ? 'bg-slate-800 text-slate-300 rounded-md' : ''}`}
                    key={i}
                    to={v.path}
                    onClick={() => setIsAddProduct(false)}
                  >
                    <v.icon size={15} type="solid" />
                    <p className="text-base">{v.label}</p>
                  </Link>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}

      <div className="mt-auto flex flex-col gap-2">
        <Button variant="outline">Settings</Button>
        <Button onClick={logout} variant="outline">
          Logout
        </Button>
      </div>
    </aside>
  );
};

export default Sidebar;

const ImportFileModal = () => {
  const { dbUser } = useAuth();
  return (
    <div>
      <div className="flex items-center mb-4">
        <CircleAlert className="h-3.5 w-3.5 text-yellow-500" />
        <p className="ml-2 text-sm font-semibold">
          Do you want to import from a file?
        </p>
      </div>
      {dbUser?.role === UserRoleEnum.READ_AND_WRITE_ADMIN ? (
        <div className="flex justify-end space-x-2">
          <Link to="/add-product">
            <Button variant="outline">No</Button>
          </Link>
          <Link to="/add-product?import=true">
            <Button className="bg-blue-600 text-white px-4 py-2 rounded-md">
              Yes
            </Button>
          </Link>
        </div>
      ) : (
        <div className="flex justify-center font-medium text-sm text-orange-400 ">
          You don&apos;t have write access
        </div>
      )}
    </div>
  );
};
